"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingXlsxVirtualSheet2CsvEvaluateWorkleaseStruct = exports.ReportingCsvVirtualSheetEvaluateWorkleaseStruct = exports.ReportingCsvVirtualSheetWorkleaseStruct = exports.ReportingXlsxVirtualSheet2CsvWorkleaseStruct = exports.WorkleaseModeIterable = void 0;
const v4_1 = require("zod/v4");
const Utils_1 = require("./Utils");
// Also exporting directly from "SharedReporting"
__exportStar(require("./Shared/SharedReporting"), exports);
exports.WorkleaseModeIterable = ['QA', 'Live'];
exports.ReportingXlsxVirtualSheet2CsvWorkleaseStruct = v4_1.z.object({
    // organizationId that initiated the worklease
    initiatingOrganizationId: v4_1.z.string(),
    creditFacilityId: v4_1.z.string().nullable(),
    creditAgreementId: v4_1.z.string().nullable(),
    // metadata:
    reportingDate: Utils_1.ZodFullDateStrStruct,
    reportName: v4_1.z.string(),
    // xlsx location
    xlsxS3Bucket: v4_1.z.string(),
    xlsxS3Key: v4_1.z.string(),
    // extraction params. See PythonXlsxVirtualSheet2CsvWorklease.
    sheets: v4_1.z.array(v4_1.z.object({
        sheetName: v4_1.z.string(),
        rows: v4_1.z.int(), // number of rows to extract starting from row 1
        // ending letter of columns to extract, optional
        // if undefined, extract all columns with text for provided rows
        // if defined, text MUST exist at least out to that column, otherwise pandas will throw
        endColumn: v4_1.z.string().optional(),
    })),
    // virtual sheet is a 2D Array of strings
    // the author of the configuration is expected to create the "csv" they want in excel
    // and we will copy into this configuration
    // the first row should be column headers, subsequent rows can string, numbers, formulas, etc
    // use "=SUM(Sheet1!A1, Sheet!A2)" for formulas
    // FORMULAS MUST BE FULLY QUALIFIED WITH SHEET NAME
    virtualSheet: v4_1.z.array(v4_1.z.array(Utils_1.SqlPrimitiveStruct)),
});
const CsvVirtualSheetCsvDetailsStruct = v4_1.z.object({
    s3Bucket: v4_1.z.string(),
    s3Path: v4_1.z.string(),
    sheetName: v4_1.z.string(),
});
exports.ReportingCsvVirtualSheetWorkleaseStruct = v4_1.z.object({
    // organizationId that initiated the worklease
    initiatingOrganizationId: v4_1.z.string(),
    creditFacilityId: v4_1.z.string().nullable(),
    creditAgreementId: v4_1.z.string().nullable(),
    // metadata:
    reportingDate: Utils_1.ZodFullDateStrStruct,
    reportName: v4_1.z.string(),
    // csvs
    csvDetails: v4_1.z.array(CsvVirtualSheetCsvDetailsStruct),
    // virtual sheet is a 2D Array of strings
    // the author of the configuration is expected to create the "csv" they want in excel
    // and we will copy into this configuration
    // the first row should be column headers, subsequent rows can string, numbers, formulas, etc
    // use "=SUM(Sheet1!A1, Sheet!A2)" for formulas
    // FORMULAS MUST BE FULLY QUALIFIED WITH SHEET NAME
    virtualSheet: v4_1.z.array(v4_1.z.array(Utils_1.SqlPrimitiveStruct)),
});
exports.ReportingCsvVirtualSheetEvaluateWorkleaseStruct = exports.ReportingCsvVirtualSheetWorkleaseStruct.extend({ recordId: v4_1.z.string() });
exports.ReportingXlsxVirtualSheet2CsvEvaluateWorkleaseStruct = exports.ReportingXlsxVirtualSheet2CsvWorkleaseStruct.extend({ recordId: v4_1.z.string() });
//# sourceMappingURL=Reporting.js.map